import { useEffect, useState } from "react";

import Image from "next/image";

import {
  DEFAULT_MODEL_THUMBNAIL,
  resolveModelThumbnailSrc,
} from "@musicfy/utils/modelThumbnail";

const ModelThumbnail: React.FC<{
  thumbnail: string | null | undefined;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}> = ({ thumbnail, alt, width = 300, height = 300, className }) => {
  const resolved = resolveModelThumbnailSrc(thumbnail);
  const [src, setSrc] = useState(resolved);

  useEffect(() => {
    setSrc(resolved);
  }, [resolved]);

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      onError={() => {
        setSrc((current) =>
          current === DEFAULT_MODEL_THUMBNAIL
            ? current
            : DEFAULT_MODEL_THUMBNAIL
        );
      }}
    />
  );
};

export default ModelThumbnail;
